import { render, staticRenderFns } from "./CollectionImagesTranslateForm.vue?vue&type=template&id=0f328b76&scoped=true&"
import script from "./CollectionImagesTranslateForm.vue?vue&type=script&lang=js&"
export * from "./CollectionImagesTranslateForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionImagesTranslateForm.vue?vue&type=style&index=0&id=0f328b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f328b76",
  null
  
)

export default component.exports